import { render, staticRenderFns } from "./SiteAlertConfigs.vue?vue&type=template&id=685b4419&scoped=true&lang=pug"
import script from "./SiteAlertConfigs.vue?vue&type=script&lang=js"
export * from "./SiteAlertConfigs.vue?vue&type=script&lang=js"
import style0 from "./SiteAlertConfigs.vue?vue&type=style&index=0&id=685b4419&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b4419",
  null
  
)

export default component.exports